import tracks from './tracks';

export default {
  tracks,
}



// WEBPACK FOOTER //
// ./src/locales/no/page/artist/management/index.js